// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"loading_spinnerContainer__B9HiW","spinner":"loading_spinner__T5Vye"};